<template>
  <div v-if="location !== undefined"
    style="align-items: center; padding: 0 32px; display: flex; flex-direction: column; position: relative; width: 100%">
    <div v-if="location.pincode.hint != '' && location.pincode.hint != null" class="infotext text-center">
      {{ location.pincode.hint }}
    </div>
    <div v-else class="infotext text-center">
      <span v-if="languageOption === 'SWEDISH'">Ange pinkod</span>
      <span v-else> Enter pincode to continue</span>
    </div>
    <div style="width: 230px">
      <v-otp-input
        v-model="pinCode"
        ref="pininput"
        :error="isPinError"
        @keydown="checkDigit"
        type="number"
        length="4"
        numeric
        autofocus
      >
      </v-otp-input>
      <div class="d-flex ml-2" v-if="isPinError">
        <div style="height: 24px; width: 24px">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>alert-circle</title>
            <path
              style="fill: #ff5252"
              d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
            />
          </svg>
        </div>
        <p style="color: #ff5252; margin-top: auto; margin-bottom: auto; margin-left: 4px">
          <span v-if="languageOption === 'SWEDISH'">Fel pinkod!</span><span v-else>Wrong pincode!</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";

export default {
  props: ["qrstring", "workspaceid", "qrworkspaceid"],
  data() {
    return {
      pinCode: "",
      isPinCodeCorrect: false,
      isPinError: false,
      location: undefined,
    };
  },
  computed: {
    ...mapGetters(["ismobileauthorized", "loading"]),
    languageOption() {
      return this.$store.getters.languageOption;
    },
  },
  watch: {
    pinCode(newPinCode) {
      if (newPinCode != "") {
        var pinArray = newPinCode.split("");
        if (pinArray.length === 4) {
          this.checkPinCode(newPinCode);
        }
      }
    },
  },
  created() {
    if (this.qrstring != undefined) {
      this.$store.dispatch("setLoading", true);
      HTTP.get(`/mobil/get/location/${this.qrstring}`)
        .then((response) => {
          if (!response.data.usePinCode) {
            this.$router.push({ name: "LegacyMobileFormSelect", params: { qrstring: this.qrstring } });
          }
          this.location = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    }
    if (this.workspaceid != undefined && this.qrworkspaceid != undefined) {
      this.$store.dispatch("setLoading", true);
      HTTP.get(`/mobil/get/location/${this.workspaceid}/${this.qrworkspaceid}`)
        .then((response) => {
          if (!response.data.usePinCode) {
            this.$router.push({
              name: "MobileFormSelect",
              params: { workspaceid: this.workspaceid, qrworkspaceid: this.qrworkspaceid },
            });
          }
          this.location = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    }
  },
  methods: {
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === "ENGLISH" ? "SWEDISH" : "ENGLISH";
    },
    checkPinCode(pinCodeToCheck) {
      this.$store.dispatch("setLoading", true);
      HTTP.post("/mobil/" + this.location.id + "/login", { pincode: pinCodeToCheck })
        .then(() => {
          this.isPinCodeCorrect = true;
          this.$store.dispatch("saveMobileAuth", { ismobileauthorized: true });
          if (this.qrstring != undefined) {
            this.$router.push({ name: "LegacyMobileFormSelect", params: { qrstring: this.qrstring } });
          }
          if (this.workspaceid != undefined && this.qrworkspaceid != undefined) {
            this.$router.push({
              name: "MobileFormSelect",
              params: { workspaceid: this.workspaceid, qrworkspaceid: this.qrworkspaceid },
            });
          }
        })
        .catch(() => {
          this.isPinError = true;
          this.pinCode = "";
          this.$refs.pininput.focus();
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    checkDigit(event) {
      if (event.key.length === 1 && isNaN(Number(event.key))) {
        event.preventDefault();
      }
    },
  },
};
</script>
